import { cn } from '@/lib/cn';

interface AvatarProps {
  src?: string | null;
  alt?: string;
  fallback?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const SIZES = {
  sm: 'h-6 w-6 text-[10px]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-14 w-14 text-sm',
  xl: 'h-32 w-32 text-base',
};

export function Avatar({ src, alt = '', fallback, className, size = 'md' }: AvatarProps) {
  const initial = (fallback ?? alt ?? '?').slice(0, 2).toUpperCase();
  return (
    <div
      className={cn(
        'relative inline-flex flex-none items-center justify-center overflow-hidden rounded-full border border-border bg-muted text-muted-foreground',
        SIZES[size],
        className,
      )}
    >
      {src ? (
        <img src={src} alt={alt} className="h-full w-full object-cover" />
      ) : (
        <span className="font-semibold">{initial}</span>
      )}
    </div>
  );
}
